// schema
import * as ISchema from "@schema";

import { commitMutation } from "react-relay";
import { Environment } from "relay-runtime";
import { addOrgTagsMutation } from "./AddOrgTags.gql";
import { modernCache } from "@network/modern-network-layer";

// MUTATION
export function addOrgTags(
  environment: Environment,
  orgRelayId: string,
  eventParentRelayId: string,
  tags: ISchema.IAddOrgTagsMutationInput["tags"],
  moveRangeV3: ISchema.IAddAndRemoveOrgTagsMutationInput["moveRangeV3"] | undefined,
  calendarId: string | undefined,
  debuggingReason: string | undefined,
  onSuccess: (response?: ISchema.IAddOrgTagsMutationPayload) => void,
  onError: (error?: any) => void,
) {
  const variables = {
    input: {
      orgRelayId,
      eventParentRelayId,
      tags,
      calendarId,
      moveRangeV3,
      debuggingReason,
    },
  };
  commitMutation(environment, {
    variables,
    onError,
    mutation: addOrgTagsMutation,
    onCompleted: (_response: ISchema.IAddOrgTagsMutationPayload, errors?: Error[]) => {
      if (!!errors) {
        onError(errors[0]);
      } else {
        // if we're not in a modern environment, modernCache will be undefined
        if (modernCache) {
          modernCache.clear();
        }
        onSuccess();
      }
    },
  });
}
